import axios from 'axios';
import { uploadImageToFirebase } from '../../utils/firebaseStorage';

const API_URL = '/api/artworks/';
const CATEGORY_URL = `${API_URL}categories`;

// --- Firebase Image Upload ---
const uploadImage = (imageFile, options = {}) =>
    uploadImageToFirebase(imageFile, { folder: 'artwork_images', ...options });

// --- API Functions ---
const addArtwork = async (artworkData, token) => {
    const config = { headers: { Authorization: `Bearer ${token}` } };
    const response = await axios.post(API_URL, artworkData, config);
    return response.data;
};

const getArtwork = async () => {
    const response = await axios.get(API_URL);
    return response.data;
};

const getAdminArtworks = async (token) => {
    const config = { headers: { Authorization: `Bearer ${token}` } };
    const response = await axios.get(API_URL + 'all', config);
    return response.data;
};

const getArtworkById = async (id) => {
    const response = await axios.get(API_URL + id);
    return response.data;
};

const deleteArtwork = async (id, token) => {
    const config = { headers: { Authorization: `Bearer ${token}` } };
    const response = await axios.delete(API_URL + id, config);
    return response.data;
};

const restoreArtwork = async (id, token) => {
    const config = { headers: { Authorization: `Bearer ${token}` } };
    const response = await axios.patch(`${API_URL}${id}/restore`, {}, config);
    return response.data;
};

const updateArtwork = async (id, artworkData, token) => {
    const config = { headers: { Authorization: `Bearer ${token}` } };
    const response = await axios.put(API_URL + id, artworkData, config);
    return response.data;
};

const updateArtworkFields = async (id, data, token) => {
    const config = { headers: { Authorization: `Bearer ${token}` } };
    const response = await axios.put(API_URL + id, data, config);
    return response.data;
};

const getArtworkCategories = async () => {
    const response = await axios.get(CATEGORY_URL);
    return response.data;
};

const updateArtworkCategory = async (category, data, token) => {
    const config = { headers: { Authorization: `Bearer ${token}` } };
    const encodedCategory = encodeURIComponent(category);
    const response = await axios.put(`${CATEGORY_URL}/${encodedCategory}`, data, config);
    return response.data;
};

const artworkService = {
    addArtwork,
    uploadImage,
    getArtwork,
    getAdminArtworks,
    getArtworkById,
    deleteArtwork,
    restoreArtwork,
    updateArtwork,
    updateArtworkFields,
    getArtworkCategories,
    updateArtworkCategory,
};

export default artworkService;
